<div class="step-container">
    <form [formGroup]="Form">
        <div id="ob-form-content" class="form-content">
            <div class="currently-working">
                <div class="form-section mb-30">
                    <div class="mb-10">
                        <label class="label-question"> Are you currently receiving other benefits? </label>
                    </div>
                    <app-toggle-confirm-dialog  id="ob-toggle-receiving-ob"
                                                #ReceivingOtherBenefits
                                               formControlName="ReceivingOtherBenefits"
                                               class="question-answer-input"
                                               (Change)="HandleReceivingOtherBenefitsToggleEvent($event)"
                                               [ShowConfirmDialogForNO]="false"
                                               [ShowConfirmDialogForU]="true"
                                               [ShowButtonU]="false"
                                               [InputId]="'ob-toggle-receiving-ob'"
                                               [InputName]="'ReceivingOtherBenefits'">
                    </app-toggle-confirm-dialog>
                </div>
                <div *ngIf="ShowReceivingOtherBenefitsQuestion" class="mb-30">
                    <div class="mb-10">
                        <label class="label-informative">Please check all that apply:</label>
                    </div>
                    <div class="mb-30">
                        <div class="checkbox-grip">
                                <mat-checkbox id="ob-retire-plan" #RetireePlan (change)="OnCheckboxChange()" formControlName="RetireePlan">
                                    <span class=checkbox-item>Retiree Plan</span>
                                </mat-checkbox>
                                <mat-checkbox id="ob-long-term" #LongTermDisability (change)="OnCheckboxChange()" formControlName="LongTermDisability">
                                    <span class=checkbox-item>Long-term Disability</span>
                                </mat-checkbox>
                                <mat-checkbox id="ob-cobra" #COBRAContinuationOfCoverage (change)="OnCheckboxChange()" formControlName="COBRAContinuationOfCoverage">
                                    <span class=checkbox-item>COBRA Continuation of Coverage</span>
                                </mat-checkbox>
                                <mat-checkbox id="ob-worker-compensation" #WorkersCompensation (change)="OnCheckboxChange()" formControlName="WorkersCompensation">
                                    <span class=checkbox-item>Worker's Compensation</span>
                                </mat-checkbox>
                                <mat-checkbox id="ob-short-term" #ShortTermDisability (change)="OnCheckboxChange()" formControlName="ShortTermDisability">
                                    <span class=checkbox-item>Short-term Disability</span>
                                </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div *ngIf="ShowSpouseQuestion">
                    <div class="mb-10">
                        <label class="label-question">Is your spouse currently receiving other benefits?</label>
                    </div>
                    <div class="mb-30">
                        <app-toggle-confirm-dialog id="ob-toggle-spouse-receiving-ob"
                                                   #SpouseReceivingOtherBenefits
                                                   formControlName="SpouseReceivingOtherBenefits"
                                                   class="question-answer-input"
                                                   (Change)="HandleSpouseToggleEvent($event)"
                                                   [ConfirmDialogSubtitle]="'This will delete everything in this section.'"
                                                   [ConfirmDialogMessage]="'Please confirm if you would like to proceed with this change.'"
                                                   [ShowLabel]="false"
                                                   [ShowConfirmDialogForNO]="false"
                                                   [ShowConfirmDialogForU]="true"
                                                   [SkipModalWithEmit]="SkipSpouseCurrentlyReceivingOtherBenefits()"
                                                   [ShowButtonU]="true"
                                                   [InputId]="'ob-toggle-spouse-receiving-ob'"
                                                   [InputName]="'SpouseReceivingOtherBenefits'">
                        </app-toggle-confirm-dialog>
                    </div>
                    <div *ngIf="ShowSpouseCurrentlyReceivingOtherBenefits">
                        <div class="mb-10">
                            <label class="label-informative">Please check all that apply:</label>
                        </div>
                        <div class="checkbox-grip">
                            <mat-checkbox id="ob-spouse-retire-plan" #SpouseRetireePlan (change)="OnCheckboxChange()" formControlName="SpouseRetireePlan">
                                <span class=checkbox-item>Spouse Retiree Plan</span>
                            </mat-checkbox>
                            <mat-checkbox id="ob-spouse-long-term" #SpouseLongTermDisability (change)="OnCheckboxChange()" formControlName="SpouseLongTermDisability">
                                <span class=checkbox-item>Spouse Long-term Disability</span>
                            </mat-checkbox>
                            <mat-checkbox id="ob-spouse-cobra" #SpouseCOBRAContinuationOfCoverage (change)="OnCheckboxChange()" formControlName="SpouseCOBRAContinuationOfCoverage">
                                <span class=checkbox-item>Spouse COBRA Continuation of Coverage</span>
                            </mat-checkbox>
                            <mat-checkbox id="ob-spouse-worker-compensation" #SpouseWorkersCompensation (change)="OnCheckboxChange()" formControlName="SpouseWorkersCompensation">
                                <span class=checkbox-item>Spouse Worker's Compensation</span>
                            </mat-checkbox>
                            <mat-checkbox id="ob-spouse-short-term" #SpouseShortTermDisability (change)="OnCheckboxChange()" formControlName="SpouseShortTermDisability">
                                <span class=checkbox-item>Spouse Short-term Disability</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

